import { sdkRequest } from '@eventbrite/http';
import * as Sentry from '@sentry/browser';
import { useCallback } from 'react';
import { formatUrl } from 'url-lib';
import { createTimezoneAdapter } from '../adapters';
import { Coordinate, TimezoneDTO, TimezoneValues } from '../types';

const formatTimezone = () => {
    const timeZone = new Intl.DateTimeFormat('en-US', {
        timeZoneName: 'long',
    })
        .formatToParts(new Date())
        .find((part) => part.type === 'timeZoneName');

    return timeZone?.value || 'UTC';
};

export class TimezoneFactory {
    public static default(): TimezoneValues {
        return {
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            label: formatTimezone(),
        };
    }
}

export const useTimezone = () => {
    const fetchTimezone = useCallback(
        ({ latitude, longitude }: Coordinate): Promise<TimezoneValues> => {
            return sdkRequest(
                formatUrl('/api/v3/system/time_zone_from_coordinates/', {
                    latitude,
                    longitude,
                }),
            )
                .then((timezoneDTO: TimezoneDTO) => {
                    const timezone = createTimezoneAdapter(timezoneDTO);
                    return timezone;
                })
                .catch((error: any) => {
                    Sentry.captureException(
                        `Error in GET /api/v3/system/time_zone_from_coordinates/`,
                        error,
                    );
                    return TimezoneFactory.default();
                });
        },
        [],
    );

    return {
        fetch: fetchTimezone,
    };
};
